<template>
<div class="np-alert np-alert-loading" v-if="show">
	<img :src="$imgList.loading_0" alt="">
</div>
</template>
<script>
export default {
	props:["options"],
	data(){
		return {
			show:false
		}
	}
}
</script>
<style lang="scss">
.np-alert-loading  {
	position: fixed;
	z-index: 9999;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0,0,0,0.4);
	img {
		position: absolute;
		left: 50%;
		top: 50%;
		z-index: 99;
		@include  transform(translate(-50%,-50%));
	}
}
</style>
